import { useCallback, useEffect } from 'react';
import { last, o, prop } from 'ramda';
import {
  notificationCenterActions,
  useNotificationCenterStore
} from '../../store';

const { FETCH_NOTIFICATIONS_LIST } = notificationCenterActions;

export const useFetchNotificationsList = () => {
  const {
    notifications,
    hasNotifications,
    notificationsPagination,
    isLoadingNotifications
  } = useNotificationCenterStore([
    'notifications',
    'hasNotifications',
    'notificationsPagination',
    'isLoadingNotifications'
  ]);
  const { limit, hasMoreNotifications } = notificationsPagination;

  // we load more notifications if:
  //  1. on initial load (hasMoreNotifications is true by default)
  //  2. if we open list and there are fewer notifications than the page limit
  //  3. if we scrolled down the page and requested more notifications

  // load notifications if there are still anything to load
  const loadNotifications = useCallback(() => {
    if (isLoadingNotifications) {
      return;
    }

    if (hasNotifications && hasMoreNotifications) {
      const lastId = o(prop('notificationId'), last)(notifications);
      FETCH_NOTIFICATIONS_LIST({ pagination: { limit, lastId } });
    }
  }, [
    FETCH_NOTIFICATIONS_LIST,
    hasMoreNotifications,
    hasNotifications,
    isLoadingNotifications,
    limit,
    notifications
  ]);

  // initial load on list open
  useEffect(() => {
    // if there are already items in the list that got there by either socket push or from previous load and some were removed
    if (notifications.length < limit) {
      loadNotifications();
    }
  }, [limit, loadNotifications, notifications.length]);

  return { loadMore: loadNotifications };
};
